"use client";

import { useEffect } from "react";

/**
 * Marks an element with `data-paused` while it's off screen, so its CSS
 * animations can be paused (lets the hero stay a server component).
 */
export function CcGeoPauseOffscreen({ targetId }: { targetId: string }) {
  useEffect(() => {
    const node = document.getElementById(targetId);
    if (!node) return;
    const observer = new IntersectionObserver(([entry]) => {
      node.toggleAttribute("data-paused", !entry.isIntersecting);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, [targetId]);

  return null;
}
